/* Halloween: spawns a ghost every now and then that floats across the viewport. */
(() => {
  const root = document.querySelector('.hk-ghosts');
  if (!root || !root.animate) return;

  const template = root.querySelector('template');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const smallScreen = window.matchMedia('(max-width: 749px)');

  const minInterval = Number(root.dataset.minInterval) || 20;
  const maxInterval = Math.max(minInterval, Number(root.dataset.maxInterval) || 45);
  const maxGhosts = Number(root.dataset.maxGhosts) || 2;
  const showOnMobile = root.dataset.mobile !== 'false';
  const maxOpacity = Number(root.dataset.opacity) || 0.85;

  const random = (min, max) => min + Math.random() * (max - min);

  let activeGhosts = 0;
  let timer = null;

  const canSpawn = () =>
    !reducedMotion.matches && !document.hidden && (showOnMobile || !smallScreen.matches) && activeGhosts < maxGhosts;

  function buildKeyframes(size, leftToRight) {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const startX = leftToRight ? -size * 1.5 : width + size * 0.5;
    const endX = leftToRight ? width + size * 0.5 : -size * 1.5;
    const baseY = random(height * 0.15, Math.max(height * 0.15, height * 0.75 - size));
    const amplitude = random(20, 60);
    const waves = random(1.5, 3);
    const opacity = maxOpacity * random(0.75, 1);
    const steps = 24;

    const keyframes = [];
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const phase = t * waves * Math.PI * 2;
      const x = startX + (endX - startX) * t;
      const y = baseY + Math.sin(phase) * amplitude;
      const tilt = Math.cos(phase) * 8 * (leftToRight ? 1 : -1);
      const fade = Math.min(1, t / 0.12, (1 - t) / 0.12);
      keyframes.push({
        transform: `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) rotate(${tilt.toFixed(1)}deg)`,
        opacity: (opacity * fade).toFixed(3),
      });
    }
    return keyframes;
  }

  function spawnGhost() {
    if (!canSpawn()) return;

    const ghost = template.content.firstElementChild.cloneNode(true);
    const size = random(56, 96) * (smallScreen.matches ? 0.7 : 1);
    const leftToRight = Math.random() < 0.5;

    ghost.style.width = `${size}px`;
    ghost.classList.toggle('hk-ghost--flip', !leftToRight);
    root.appendChild(ghost);
    activeGhosts++;

    const animation = ghost.animate(buildKeyframes(size, leftToRight), {
      duration: random(8000, 14000),
      easing: 'linear',
      fill: 'forwards',
    });
    const remove = () => {
      ghost.remove();
      activeGhosts--;
    };
    animation.onfinish = remove;
    animation.oncancel = remove;
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      spawnGhost();
      schedule(random(minInterval, maxInterval) * 1000);
    }, delay);
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimeout(timer);
    } else {
      schedule(random(minInterval, maxInterval) * 1000);
    }
  });

  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) root.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
  });

  schedule(random(5000, 10000));
})();
